// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2n25D","legacyBtn":"MutateMid_legacyBtn__37BwJ"};